import { RadioGroup as HeadlessRadioGroup } from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';

interface RadioOption {
  label: string;
  value: string;
  icon?: React.ReactNode;
  iconPosition?: 'start' | 'end';
}

interface RadioGroupProps {
  label?: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function RadioGroup({
  label,
  options,
  value,
  onChange,
  className,
}: RadioGroupProps): JSX.Element {
  return (
    <HeadlessRadioGroup value={value} onChange={onChange}>
      {label && (
        <HeadlessRadioGroup.Label className="block text-md text-gray-600 mb-2 leading-6 ">
          {label}
        </HeadlessRadioGroup.Label>
      )}
      <div className={clsx('flex gap-4', className)}>
        {options.map((option) => (
          <HeadlessRadioGroup.Option
            key={option.value}
            value={option.value}
            className={({ checked }) =>
              clsx(
                'flex items-center py-2 px-3 gap-2 cursor-pointer rounded-lg',
                checked
                  ? 'bg-inherit text-primary'
                  : 'bg-inherit text-gray-700',
              )
            }
          >
            {({ checked }) => (
              <div className="flex items-center gap-1">
                <div
                  className={clsx(
                    'flex items-center justify-center w-4 h-4 rounded-full border border-[#1F1F1F]',
                  )}
                >
                  {checked && (
                    <div className="w-2 h-2 rounded-full bg-primary" />
                  )}
                </div>
                <span
                  className={clsx(
                    'flex items-center text-md font-normal leading-6',
                    checked ? 'text-primary' : 'text-gray-600',
                  )}
                >
                  {option.label}
                </span>
                {option.icon && option.iconPosition === 'end' && (
                  <span
                    className={clsx(
                      'flex items-center justify-center w-5 h-5 flex-shrink-0',
                      checked ? 'text-primary' : 'text-gray-600',
                    )}
                  >
                    {option.icon}
                  </span>
                )}
              </div>
            )}
          </HeadlessRadioGroup.Option>
        ))}
      </div>
    </HeadlessRadioGroup>
  );
}
